import styled, { css } from 'styled-components';

interface CharacterCounterProps {
  currentLength: number;
  maxLength: number;
  className?: string;
}

const CharacterCounter = ({ currentLength, maxLength, className }: CharacterCounterProps) => {
  const isNearLimit = currentLength > maxLength * 0.8;
  const isAtLimit = currentLength >= maxLength;
  const counterText = `${currentLength}/${maxLength}`;

  return (
    <CounterWrapper className={className} $isNearLimit={isNearLimit} $isAtLimit={isAtLimit}>
      {counterText}
    </CounterWrapper>
  );
};

const CounterWrapper = styled.div<{ $isAtLimit: boolean; $isNearLimit: boolean }>`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.brand.textSecondary};
  text-align: right;
  margin-top: 4px;

  ${({ $isNearLimit, theme }) =>
    $isNearLimit &&
    css`
      color: ${theme.palette.warning?.main || '#ff9800'};
    `}

  ${({ $isAtLimit, theme }) =>
    $isAtLimit &&
    css`
      color: ${theme.palette.error?.main || '#f44336'};
      font-weight: 500;
    `}
`;

export { CharacterCounter };
